import React, { useEffect, useState, createRef } from 'react'
import { Col, Empty, Row, Timeline } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LogsData } from 'Store/stock/types'
import { LoadingView } from 'Components/modal'
import theme, { MyTheme } from 'Components/common/Theme'
import { formatDateTime } from 'helpers/format'
import Label from 'Components/text/Label'
import { PrimaryButton } from 'Components/button'
import { PrinterOutlined } from '@ant-design/icons'
import { getManageStockLogsAPI } from 'Store/stock/api'
import { ManageStockLogsReq } from 'Store/stock/types'
import { selectStockLogs, selectStockLogsEvent } from 'Store/stock/selector'
import ManageStockPDF from './ManageStockPDF'
import ReactToPrint from 'react-to-print'

type Props = {
  isShow: boolean
  onClose: () => void
  product_id: number
  product_option_id: number
} & ReduxProps

const StockLogsDrawer = (props: Props) => {
  const { isShow, onClose, event, product_id, product_option_id, currentUser, logs } = props
  const list = logs.data
  const product = logs.productData
  const [elRefs, setElRefs] = useState([] as any[])

  const dispatch = useDispatch()

  const onGetDataList = (): void => {
    const req: ManageStockLogsReq = {
      product_id: product_id,
      product_option_id: product_option_id,
      page: 1,
      per_page: 100,
    }
    dispatch(getManageStockLogsAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
    }
  }, [isShow, product_option_id, product_id])

  useEffect(() => {
    if (logs && logs.data && logs.data.length > 0) {
      const ref = logs.data.map((item, i) => elRefs[i] || createRef())
      setElRefs(ref)
    }
  }, [logs, logs.data])

  const getTimeLines = () => {
    const timeline = [] as any
    list &&
      list.map((item: LogsData, index: number) => {
        if (item && item.logs && item.logs.length > 0) {
          timeline.unshift(
            <Timeline.Item key={index} dot={<StartDot style={{ backgroundColor: theme.colors.primary }} />}>
              <Row justify="space-between" gutter={[8, 8]}>
                <Col>
                  <span style={{ color: theme.colors.primary }}>
                    ปรับออก, {item.quantity} {product?.uom?.name || ''}
                  </span>
                  <br />
                  <LabelStyle>วัน/เวลา : {formatDateTime(item.created_at || '')}</LabelStyle> <br />
                  <LabelStyle>เหตุผล : {item.reason} </LabelStyle> <br />
                  <LabelStyle>ผู้ทำรายการ : {item.username}</LabelStyle>
                </Col>
                <Col>
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <PrimaryButton
                          size="small"
                          text="พิมพ์"
                          icon={<PrinterOutlined />}
                          onClick={() => {}}
                        />
                      )
                    }}
                    content={() => elRefs[index] && elRefs[index].current}
                    documentTitle={`รายงานการปรับสินค้าออกจากคลัง - ${item.created_at}`}
                  />
                </Col>
              </Row>
            </Timeline.Item>,
          )
        }
      })
    timeline.push(
      <Timeline.Item key="start" dot={<StartDot />}>
        <LabelStyle>เริ่มต้น</LabelStyle>
      </Timeline.Item>,
    )
    return timeline
  }

  return (
    <DetailDrawer
      title={'ประวัติการปรับสินค้าออกจากสินค้าคงคลัง'}
      width={'30%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={event.IsLoading} />
      <Row>
        <Col span={24}>
          {list && list.length > 0 ? (
            <Timeline>{getTimeLines()}</Timeline>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Col>
      </Row>
      {list &&
        list.map((item, i) => {
          return (
            <Row ref={elRefs[i]} key={i}>
              <Col span={24}>
                <ManageStockPDF detail={item} product={product} productOptionId={product_option_id} />
              </Col>
            </Row>
          )
        })}
    </DetailDrawer>
  )
}

const LabelStyle = styled(Label)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const StartDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectStockLogsEvent(state),
    logs: selectStockLogs(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(StockLogsDrawer)
